import * as React from "react"

import { cn } from "../utils"

export const FORCE_AUTOCOMPLETE_OFF_ATTRS = {
  autoComplete: "off",
  "data-1p-ignore": "true",
  "data-op-ignore": "true",
  "data-bwignore": "true",
  "data-lpignore": "true",
  "data-form-type": "other",
} as const

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, autoComplete, value, ...props }, ref) => {
    const passwordManagerIgnoreProps = autoComplete === "off" ? FORCE_AUTOCOMPLETE_OFF_ATTRS : {}

    return (
      <input
        type={type}
        className={cn(
          "border-input file:text-foreground placeholder:text-input-placeholder focus-visible:border-ring flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        autoComplete={autoComplete}
        value={value === null ? "" : value}
        {...passwordManagerIgnoreProps}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
